import PropTypes from "prop-types";
import personClass from "./person/personClass.js";
import tyomaaAuthClass from "src/data/auth/tyomaaAuthClass";
import { hashCode } from "src/components/js/statics1";
import { Typography } from "@mui/material";

export default class tyomaaClass {
  constructor() {
    this.tyomaaId = 0;
    this.asiakasId = 0;
    this.deletedTime = null;
    this.persons = [new personClass()];
    this.tyomaaContactPersonId = 0;
    this.tyomaaNimi = "";
    this.tyomaaOsoite1 = "";
    this.tyomaaOsoite2 = "";
    this.tyomaaOsoite3 = "";
    this.tyomaaOsoite4 = "";
    this.tyomaaAjoOhje = "";
    this.keikkaAjoOhje = "";
    this.tyomaaMemo = "";
    this.auth = new tyomaaAuthClass();
    this.lat = "";
    this.lng = "";
    this.placeId = "";
    this.formattedAddress = "";
    this.laskuViite = "";
    this.asiakasId = 0;
    this.ownerAsiakasId = null;
    this.tyomaaNum = "";
  }
  get isDeleted() {
    return this.deletedTime !== null;
  }

  setTyomaa(obj) {
    if (!obj) return;
    this.tyomaaId = obj.tyomaaId;
    this.asiakasId = obj.asiakasId;
    this.deletedTime = obj.deletedTime;
    this.tyomaaNimi = obj.tyomaaNimi;
    this.tyomaaOsoite1 = obj.tyomaaOsoite1;
    this.tyomaaOsoite2 = obj.tyomaaOsoite2;
    this.tyomaaOsoite3 = obj.tyomaaOsoite3;
    this.tyomaaOsoite4 = obj.tyomaaOsoite4;
    this.tyomaaMemo = obj.tyomaaMemo;
    this.laskuViite = obj.laskuViite;
    this.asiakasId = obj.asiakasId;
    this.tyomaaAjoOhje = obj.tyomaaAjoOhje;
    this.keikkaAjoOhje = obj.tyomaaAjoOhje;
    this.tyomaaContactPersonId = obj.tyomaaContactPersonId;
    this.originalHash = "";
    this.lat = obj.lat;
    this.lng = obj.lng;
    this.placeId = obj.placeId;
    this.formattedAddress = obj.formattedAddress;
    this.ownerAsiakasId = obj.ownerAsiakasId || obj.tyomaa_ownerAsiakasId;
    this.tyomaaNum = obj.tyomaaNum;
  }

  OsoiteRows() {
    return (
      <>
        <Typography variant="h7" align="left" color="primary" gutterBottom>
          {this.tyomaaNimi && (
            <>
              {this.tyomaaNimi}
              <br />
            </>
          )}
          {this.tyomaaOsoite1 && (
            <>
              {this.tyomaaOsoite1}
              <br />
            </>
          )}
          {this.tyomaaOsoite2 && (
            <>
              {this.tyomaaOsoite2}
              <br />
            </>
          )}
          {(this.tyomaaOsoite3 || this.tyomaaOsoite4) && (
            <>
              {this.tyomaaOsoite3 + " " + this.tyomaaOsoite4}
              <br />
            </>
          )}
        </Typography>
      </>
    );
  }

  addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
  }
  get tyomaaString() {
    return (this.tyomaaNimi || "") + this.tyomaaOsoiteString;
  }
  get tyomaaOsoiteString() {
    return (
      (this.tyomaaOsoite1 ? this.tyomaaOsoite1 : "") +
      (this.tyomaaOsoite2 ? ", " + this.tyomaaOsoite2 : "") +
      " " +
      (this.tyomaaOsoite3 ? ", " + this.tyomaaOsoite3 : "") +
      " " +
      (this.tyomaaOsoite4 || "")
    )
      .replaceAll("  ", " ")
      .trim();
  }

  get tyomaaIsModified() {
    return this.tyomaaHash() !== this.originalHash;
  }
  tyomaaError(allowEdit = true) {
    if (this.tyomaaId === 0)
      if (allowEdit) return "Syötä työmaatiedot, osoite yms";
      else return "Työmaata ei ole valittu";
    if (this.tyomaaOsoite1.length < 5)
      if (allowEdit) return "Syötä työmaaosoite";
      else return "Toimitusosoitetta ei ole";
    return null;
  }
  get tyomaaHash() {
    const _tyomaa = this.tyomaaId;
    const _person = this.tyomaaContactPersonId;
    const _keikkaAjo = hashCode(this.keikkaAjoOhje);
    const _tyomaaAjo = hashCode(this.tyomaaAjoOhje);
    const _memo = hashCode(this.tyomaaMemo);
    const _osoite = hashCode(this.tyomaaOsoiteString);
    const _nimi = hashCode(this.tyomaaNimi);
    const _asiakasId = this.asiakasId || 0;
    return (
      _tyomaa * 7 + _person * 5 + _keikkaAjo + _tyomaaAjo + _memo + _osoite + _nimi + _asiakasId
    );
  }
}

tyomaaClass.propTypes = { keikkaAika: PropTypes.date };
